import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=c52ef8d4&lang=pug&"
import script from "./tip.vue?vue&type=script&lang=js&"
export * from "./tip.vue?vue&type=script&lang=js&"
import style0 from "./tip.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports